import type { NewsItem } from '../types/news';

export const newsArticles: NewsItem[] = [
  {
    id: 1,
    title: '新产品发布：2023年创新解决方案',
    type: 'product',
    date: '2023-06-15',
    image: '/images/news/img_1.png',
    summary: '我们很高兴地宣布推出新一代农业机械解决方案，这将为农业生产带来革命性的改变。',
    content: '<p>我们很高兴地宣布推出新一代农业机械解决方案。这些创新产品将为农业生产带来革命性的改变，提高生产效率，降低运营成本。</p><h3>主要特点</h3><ul><li>智能化操作系统</li><li>节能环保设计</li><li>高效作业能力</li><li>人性化界面</li></ul><h3>技术创新</h3><p>新一代产品采用了多项创新技术，包括：</p><ul><li>AI辅助驾驶系统</li><li>智能故障诊断</li><li>远程监控功能</li><li>精准作业控制</li></ul><h3>应用场景</h3><p>这些解决方案适用于多种农业场景，能够显著提升作业效率和质量。</p>'
  },
  {
    id: 2,
    title: '行业奖项认可',
    type: 'company',
    date: '2023-07-20',
    image: '/images/news/award.jpg',
    summary: '我们在创新和质量方面的承诺获得了多个行业奖项的认可。',
    content: '<p>我们很荣幸地宣布，公司凭借在农业机械领域的创新成就和卓越品质，荣获多个行业权威奖项。</p><h3>获奖项目</h3><ul><li>年度最佳创新奖</li><li>质量卓越奖</li><li>用户满意度第一</li><li>技术领先奖</li></ul><h3>评审认可</h3><p>评审团队高度评价了我们在以下方面的成就：</p><ul><li>产品创新能力</li><li>质量管理体系</li><li>客户服务水平</li><li>技术研发实力</li></ul><h3>未来展望</h3><p>这些奖项是对我们过去工作的肯定，也将激励我们继续追求卓越。</p>'
  },
  {
    id: 3,
    title: 'CEO独家专访',
    type: 'company',
    date: '2023-08-10',
    image: '/images/news/interview.jpg',
    summary: '我们的CEO分享了公司愿景和未来发展计划。',
    content: '<p>在本次独家专访中，我们的CEO详细分享了公司的发展愿景和未来规划。</p><h3>发展战略</h3><ul><li>技术创新投入</li><li>市场布局扩张</li><li>产品线优化</li><li>服务体系升级</li></ul><h3>行业展望</h3><p>对于行业发展趋势，CEO认为：</p><ul><li>智能化将成为主流</li><li>环保要求会更严格</li><li>用户需求更多元化</li><li>服务将更加重要</li></ul><h3>未来计划</h3><p>公司将继续专注于产品创新和服务提升，为客户创造更大价值。</p>'
  },
  {
    id: 4,
    title: '新技术整合',
    type: 'product',
    date: '2023-09-05',
    image: '/images/news/img_2.png',
    summary: '整合前沿技术，提升产品性能和用户体验。',
    content: '<p>我们成功将多项前沿技术整合到产品中，显著提升了性能和用户体验。</p><h3>技术亮点</h3><ul><li>智能控制系统</li><li>远程监控平台</li><li>自动化操作</li><li>数据分析功能</li></ul><h3>性能提升</h3><p>通过技术整合，产品在以下方面获得显著提升：</p><ul><li>作业效率提高30%</li><li>能耗降低20%</li><li>维护成本减少15%</li><li>操作更加简便</li></ul><h3>用户反馈</h3><p>新技术的应用获得了用户的积极评价，特别是在易用性和效率方面。</p>'
  },
  {
    id: 5,
    title: '全球市场扩张',
    type: 'company',
    date: '2023-10-15',
    image: '/images/news/img.png',
    summary: '扩大在主要国际市场的业务，为全球客户提供更好的服务。',
    content: '<p>我们正式启动全球市场扩张计划，将业务拓展到更多国际市场。</p><h3>市场布局</h3><ul><li>东南亚地区</li><li>南美市场</li><li>欧洲区域</li><li>非洲市场</li></ul><h3>本地化服务</h3><p>为了更好地服务国际客户，我们将：</p><ul><li>建立本地服务中心</li><li>组建本地技术团队</li><li>提供本地化培训</li><li>建设备件供应网络</li></ul><h3>发展目标</h3><p>通过市场扩张，我们致力于成为全球领先的农业机械解决方案提供商。</p>'
  }
]; 